var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCar = function SvgCar(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "currentColor",
    viewBox: "0 0 20 14",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.353 2H7v3H3.478l.95-2.372A.995.995 0 0 1 5.353 2M8.5 5V2h2.537c.304 0 .591.138.782.375L13.919 5zm8.006.031-3.125-3.906A3 3 0 0 0 11.037 0H5.353A3 3 0 0 0 2.57 1.884l-1.3 3.254A2 2 0 0 0 0 7v3.5c0 .553.447 1 1 1h1.04a3 3 0 0 0 5.92 0h4.08a3 3 0 0 0 5.92 0H19c.553 0 1-.447 1-1V9a4 4 0 0 0-3.494-3.969M13.584 10.5a1.5 1.5 0 1 1 2.829 1 1.5 1.5 0 1 1-2.829-1M5 9.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  })));
};
export default SvgCar;